import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirlineSeatIndividualSuiteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airline_seat_individual_suite"}/>
}
